<template>
  <div>
    <dashboard-desktop v-if="screenType === 'desktop'"></dashboard-desktop>
    <dashboard-mobile v-else></dashboard-mobile>
  </div>
</template>

<script>
import DashboardDesktop from "@/components/Pages/Desktop/Dashboard/DashboardDesktop";
import DashboardMobile from "@/components/Pages/Mobile/Dashboard/DashboardMobile";

export default {
  name: "DashboardIndexMain",
  components: {DashboardMobile, DashboardDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>